import React from 'react'
import "../assets/Css/about_text.css"
import "../index.css"
import h1 from "../assets/images/n1.jpg";
import h2 from "../assets/images/n2.jpg";
import h3 from "../assets/images/n3.jpg";
export default function About_text() {
  return (
<>
<div className="about-text-wraaper page-width">

<div className="about-text-container">
  <div className="about-cont-title"><p>ABOUT ffffXEBRAND</p></div>
  <div className="about-cont-content">
  <h4><span  className='hover-img'><img src={h1} alt="" /></span> We belief that scalability is the ultimate Way for unlocking boundless potential. <span  className='hover-img'>  <img src={h3} alt="" />  </span>We help your journey with creative prowess and strategic innovation.</h4>
</div>
</div>

</div>


</>
  )
}
